import { Reducer } from 'redux'

import { Anexo, FotoDocumentosState, FotoDocumentosTypes } from './types'

const INITIAL_STATE: FotoDocumentosState = {
  anexos: [],
  isDone: false,
  isLoading: false,
  isError: false,
  rollbackRouterError: '',
  indice: 0,
}

const deleteAnexo = (anexosAtual: Anexo[], indice: number) => {
  const novaListaAnexos = anexosAtual || []
  return novaListaAnexos.filter((_, index) => index !== indice)
}

const addAnexo = (anexosAtual: Anexo[], anexoNovo: Anexo) => {
  const anexos = anexosAtual || []
  return [...anexos, anexoNovo]
}

const reducer: Reducer<FotoDocumentosState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FotoDocumentosTypes.SET_ANEXOS:
      return {
        ...state,
        anexos: Array.isArray(action.payload)
          ? action.payload
          : addAnexo(state.anexos, action.payload),
      }
    case FotoDocumentosTypes.DELETE_ANEXO:
      return {
        ...state,
        anexos: deleteAnexo(state.anexos, action.payload),
      }
    case FotoDocumentosTypes.SET_IS_DONE:
      return { ...state, isDone: action.payload }
    case FotoDocumentosTypes.SET_IS_LOADING:
      return { ...state, isLoading: action.payload }
    case FotoDocumentosTypes.SET_IS_ERROR:
      return { ...state, isError: action.payload }
    case FotoDocumentosTypes.SET_ROLLBACK_ROUTER_ERROR:
      return { ...state, rollbackRouterError: action.payload }
    case FotoDocumentosTypes.RESET:
      return { ...INITIAL_STATE }
    default:
      return state
  }
}

export default reducer
